import { z } from 'zod';
import { UseSchema } from '../../common';

//glyph: annotationEntry.glyph,
// title: annotationEntry.title,
// description: annotationEntry.description,

export const annotationBaseDtoSchema = z.object({
  sceneEntityId: z
    .string()
    .nullable()
    .optional()
    .describe('The ID of the scene entity to which the annotation belongs'),
  markerColor: z.string().max(255).nullable().optional().describe('The CSS marker color'),
  glyph: z.string().max(255).nullable().optional().describe('The glyph of the annotation'),
  title: z.string().max(255).nullable().optional().describe('The title of the annotation'),
  description: z.string().nullable().optional().describe('The description of the annotation'),
  positionX: z.number().nullable().optional().describe('The X position of the annotation'),
  positionY: z.number().nullable().optional().describe('The Y position of the annotation'),
  positionZ: z.number().nullable().optional().describe('The Z position of the annotation'),
});

export const annotationCreateDtoSchema = annotationBaseDtoSchema.extend({
  projectEntryId: z
    .string()
    .uuid()
    .describe('The ID of the project to which the annotation belongs'),
});

@UseSchema(annotationCreateDtoSchema)
export class AnnotationCreateDto {}
export interface AnnotationCreateDto extends z.input<typeof annotationCreateDtoSchema> {}
